<div fxLayoutAlign="start center" fxLayoutGap="8px" style="margin-bottom: 24px">
  <h2 class="nomargin" fxFlex>{{ dialogData.mode === 'create' ? 'Add' : 'Edit' }} location</h2>
</div>

<google-map
  *ngIf="(apiLoaded | async) === true"
  height="400px"
  width="100%"
  class="gmap"
  [options]="{ zoom: dialogData.mode === 'create' ? 2 : 12 }"
  [center]="{ lat: +dialogData.location.lat, lng: +dialogData.location.lng }"
  (mapClick)="onMapClick($event)">
  <map-marker *ngFor="let marker of markers" [position]="marker.position" [options]="marker.options"></map-marker>
</google-map>

<div *ngIf="dialogData.location.lat && dialogData.location.lng" style="margin-top: 24px">
  <label>Location label</label>
  <mat-form-field class="fw">
    <input matInput placeholder="Location name" [(ngModel)]="dialogData.location.name" />
    <mat-hint>
      {{
        dialogData.location.lat && dialogData.location.lng
          ? 'Lat: ' + dialogData.location.lat + ', Lng: ' + dialogData.location.lng
          : 'Click on the map to set the location'
      }}
    </mat-hint>
  </mat-form-field>
</div>

<div style="display: none">
  <input
    *ngIf="apiLoaded | async"
    #mapSearchField
    type="text"
    class="input-search"
    [placeholder]="this.dialogData.mode === 'create' ? 'Search to find a location' : 'Search'" />
</div>
